(function(){
  var $=function(s,r){return (r||document).querySelector(s)};

  /* faint static grain */
  var c=$('#ng-grain');
  function grain(){
    if(!c)return;
    try{
      var w=c.width=Math.ceil(innerWidth/2),h=c.height=Math.ceil(innerHeight/2);
      var x=c.getContext('2d'),d=x.createImageData(w,h);
      for(var i=0;i<d.data.length;i+=4){var v=Math.random()*255|0;d.data[i]=d.data[i+1]=d.data[i+2]=v;d.data[i+3]=255}
      x.putImageData(d,0,0);
    }catch(e){}
  }
  grain();var rt;addEventListener('resize',function(){clearTimeout(rt);rt=setTimeout(grain,200)});

  /* clock in the visitor's own time */
  var ck=$('#ng-clock');
  function pd(n){return String(n).padStart(2,'0')}
  function tick(){if(!ck)return;var d=new Date();ck.textContent='ng — '+pd(d.getHours())+':'+pd(d.getMinutes())+':'+pd(d.getSeconds())}
  tick();setInterval(tick,1000);

  /* product form: size picker + add to bag without leaving the page */
  var form=$('[data-ng-product]');
  if(form){
    var idInput=$('input[name="id"]',form),msg=$('[data-ng-msg]',form),btn=$('[data-ng-add]',form),count=$('[data-ng-count]');
    var picked=!!form.querySelector('input[name="ng-variant"]:checked') || form.hasAttribute('data-single');
    form.addEventListener('change',function(e){
      if(e.target.name==='ng-variant'){idInput.value=e.target.value;picked=true;if(msg)msg.textContent=msg.getAttribute('data-default')}
    });
    form.addEventListener('submit',function(e){
      e.preventDefault();
      if(!picked){msg.textContent='pick a size.';return}
      btn.disabled=true;
      fetch((window.Shopify&&Shopify.routes?Shopify.routes.root:'/')+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:Number(idInput.value),quantity:1}]})})
        .then(function(r){return r.json().then(function(j){if(!r.ok)throw j;return j})})
        .then(function(){return fetch((window.Shopify&&Shopify.routes?Shopify.routes.root:'/')+'cart.js').then(function(r){return r.json()})})
        .then(function(cart){if(count)count.textContent=cart.item_count;var lab=form.querySelector('input[name="ng-variant"]:checked');msg.textContent='added.'+(lab?' size '+lab.getAttribute('data-label').toLowerCase()+'.':'')})
        .catch(function(err){msg.textContent=(err&&err.description)?String(err.description).toLowerCase():'that didn’t go through. try again.'})
        .finally(function(){btn.disabled=false});
    });
  }
})();
